/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "suspended-customers",
	data() {
		return {
			suspendedCustomers: [],
			suspendedCustomerHeadings: [
				{
					text: "Company",
					field: "registeredCompanyName"
				},
				{
					text: "Suspension Date",
					field: "suspensionDateFormatted"
				}
			],
			pagingDetails: {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys: {
				reinstate: "reinstate"
			},
			reinstateModal: {
				showModal: false,
				loading: false,
				modalId: "reinstateCompanyModal",
				title: "Reinstate Customer",
				message: "Are you sure you want to reinstate this customer? This action will allow them to place orders again.",
				selectedCompanyId: null,
				selectedCompanyName: ""
			},
			filterStateChanged: false,
			filter: {
				searchQuery: ""
			},
			loading: false
		};
	},
	methods: {
		getSuspendedCustomers() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.searchQuery || null,
				isActive: true, // We want all suspended customers regardless of active status
				suspended: true, // This is the key filter for suspended customers
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isCollectionCompany: true,
				isDeliveryCompany: true,
				isExTankCompany: true
			};
			
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
						successResponse.data.responseStatus, 
						successResponse.data.httpStatusCode, 
						successResponse.data.message
					);
					if (isSuccess) {
						this.suspendedCustomers = successResponse.data.result || [];
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo?.thisPage || 1;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo?.totalPages || 1;
						
						// Add actions and format data for each suspended customer
						for (let i = 0; i < this.suspendedCustomers.length; i++) {
							// Format suspension date if available
							if (this.suspendedCustomers[i].suspendedOn) {
								this.suspendedCustomers[i].suspensionDateFormatted = this.$filters.dateShortForm(this.suspendedCustomers[i].suspendedOn);
							} else {
								this.suspendedCustomers[i].suspensionDateFormatted = "N/A";
							}
							
							this.suspendedCustomers[i].actions = [
								{
									name: "Reinstate",
									key: this.actionKeys.reinstate,
									elementId: "btnReinstateCustomer",
									cssClass: "btn-outline-success"
								}
							];
						}
					}
					this.filterStateChanged = false;
					this.loading = false;
				}
			).catch(error => {
				console.error("Error fetching suspended customers:", error);
				this.loading = false;
				this.filterStateChanged = false;
			});
		},
		
		onCustomerActionClicked(actionData) {
			if (actionData.action === this.actionKeys.reinstate) {
				this.reinstateModal.selectedCompanyId = actionData.data.companyId;
				this.reinstateModal.selectedCompanyName = actionData.data.registeredCompanyName;
				this.reinstateModal.message = `Are you sure you want to reinstate "${actionData.data.registeredCompanyName}"? This action will allow them to place orders again.`;
				this.reinstateModal.showModal = true;
			}
		},
		
		onReinstateConfirmed(confirmed) {
			if (confirmed) {
				this.reinstateModal.loading = true;
				let request = {
					companyId: this.reinstateModal.selectedCompanyId
				};
				
				customerService.reinstateSuspendedCompany(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(
							successResponse.data.responseStatus, 
							successResponse.data.httpStatusCode, 
							successResponse.data.message
						);
						if (isSuccess) {
							this.getSuspendedCustomers(); // Refresh the data
						}
						this.reinstateModal.loading = false;
						this.reinstateModal.showModal = false;
					}
				).catch(error => {
					console.error("Error reinstating customer:", error);
					this.reinstateModal.loading = false;
					this.reinstateModal.showModal = false;
				});
			} else {
				this.reinstateModal.showModal = false;
			}
		},
		
		onPagingUpdated(pagingData) {
			this.pagingDetails.pageNumber = pagingData.pageNumber;
			this.pagingDetails.pageSize = pagingData.pageSize;
			this.getSuspendedCustomers();
		},
		
		onFilterSearchClicked() {
			this.pagingDetails.pageNumber = 1; // Reset to first page when filtering
			this.getSuspendedCustomers();
		},
		
		refreshSuspendedCustomers() {
			this.getSuspendedCustomers();
		},
		
		navigateToAccounts() {
			this.$router.push('/accounts');
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Suspended Customers");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Suspended Customers");
		}
	},
	
	watch: {
		'filter.searchQuery': function() {
			this.filterStateChanged = !this.filterStateChanged;
		}
	},
	
	mounted: function () {
		this.getSuspendedCustomers();
		this.setBreadcrumbs();
	}
};